module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--jumper",
    style: (_vm.styles)
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-588a8eba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Jumper.vue
// module id = 925
// module chunks = 170